import { NavLink } from "react-router-dom";
import PrimaryBtn from "../../components/primaryBtn/PrimaryBtn";
import "./Thanks.scss";

const Thanks = () => {
  return (
    <section className="thanks_sec">
      <div className="content_wrap">
        <h2 className="text-center gold">Thanks!</h2>
        <p className="text-center gold">
          Thank you for reaching out! Our team will get back to you soon.
        </p>
        <NavLink to="/" className="mt-3">
        <button className="square_btn">Home</button>        
        </NavLink>
      </div>
    </section>
  );
};

export default Thanks;
